import { useState, useEffect } from "react";
import { BodyWithClass, Btn } from "@client/ui";
import { useNavigate } from "react-router-dom";

const DriverHeroSection: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const driverTypes = [
    {
      type: "Car Driver",
      image: "/image/driver-home.png",
      description:
        "Connect people across the city and earn competitive rates with every ride.",
    },
    {
      type: "Motorbike Driver",
      image: "/image/motorbike.jpg",
      description:
        "Make quick deliveries and navigate through traffic efficiently.",
    },
    {
      type: "Scooter Driver",
      image: "/image/scooter.jpg",
      description: "Perfect for short distance deliveries in urban areas.",
    },
    {
      type: "Bike Rider",
      image: "/image/bike.jpg",
      description:
        "Eco-friendly delivery option for the environmentally conscious.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % driverTypes.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, [driverTypes.length]);

  const navigateToDriverPage = () => {
    navigate("/driver");
  };

  return (
    <div className="bg-background-light max-w-full w-[700px] m-auto py-8 px-4 rounded-[12px] mb-[50px]">
      <BodyWithClass
        className="font-primary text-[24px] text-center font-semibold"
        text="Become Tapzus Hero Drivers"
      />
      <div className="mt-4 text-center">
        <BodyWithClass
          className="hero-section text-[20px] font-medium"
          text="Not all heroes wear masks—some drive with us."
        />
        <BodyWithClass
          className="additional-text text-[18px] text-gray-600 mt-2"
          text="Join a community of drivers making a difference every day by connecting people, delivering smiles, and creating unforgettable experiences."
        />
        <BodyWithClass
          className="benefits-text text-[16px] text-gray-500 mt-4"
          text="Enjoy flexible hours, competitive earnings, and the freedom to drive on your own schedule while being part of something bigger."
        />
      </div>

      <div className="w-full border-primary border-t-1 mt-6 pt-[30px]">
        <BodyWithClass
          className="image-text text-[20px] font-medium text-center mb-4"
          text="Do you have any of these? Join us today!"
        />

        <div className="relative h-[300px] overflow-hidden rounded-lg shadow-md">
          {/* Images with fade transition */}
          {driverTypes.map((driver, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 flex flex-col ${
                index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
              }`}
            >
              <div className="relative h-[220px] overflow-hidden">
                <img
                  src={driver.image}
                  alt={driver.type}
                  className="w-full h-full object-cover transition-transform duration-700 ease-in-out transform hover:scale-105"
                />
                <div className="absolute top-0 left-0 bg-gradient-to-r from-blue-900/70 to-transparent px-4 py-2 rounded-br-lg">
                  <h3 className="text-white font-bold text-lg">
                    {driver.type}
                  </h3>
                </div>
              </div>
              <div className="bg-white p-4 h-[80px] flex items-center justify-center">
                <p className="text-center text-gray-700">
                  {driver.description}
                </p>
              </div>
            </div>
          ))}

          <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
            {driverTypes.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-colors ${
                  index === currentIndex ? "bg-blue-600" : "bg-gray-300"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="mt-8 text-center">
        <Btn
          text="Become a Driver"
          onClick={navigateToDriverPage}
          style={{
            backgroundColor: "#3b82f6",
            color: "white",
            padding: "10px 24px",
            borderRadius: "8px",
            fontWeight: "600",
          }}
        />
      </div>
    </div>
  );
};

export default DriverHeroSection;
